"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtraPaymentType = exports.PaymentType = exports.StayEntryType = exports.StayEntryItemType = void 0;
var StayEntryItemType;
(function (StayEntryItemType) {
    StayEntryItemType[StayEntryItemType["UNKNOWN"] = 0] = "UNKNOWN";
    StayEntryItemType[StayEntryItemType["NUMBER_INT"] = 1] = "NUMBER_INT";
    StayEntryItemType[StayEntryItemType["NUMBER_DOUBLE"] = 2] = "NUMBER_DOUBLE";
    StayEntryItemType[StayEntryItemType["ENUM"] = 3] = "ENUM";
})(StayEntryItemType || (exports.StayEntryItemType = StayEntryItemType = {}));
var StayEntryType;
(function (StayEntryType) {
    StayEntryType[StayEntryType["UNKNOWN"] = 0] = "UNKNOWN";
    StayEntryType[StayEntryType["SHORT"] = 1] = "SHORT";
    StayEntryType[StayEntryType["LONG"] = 2] = "LONG";
})(StayEntryType || (exports.StayEntryType = StayEntryType = {}));
var PaymentType;
(function (PaymentType) {
    PaymentType[PaymentType["UNKNOWN"] = 0] = "UNKNOWN";
    PaymentType[PaymentType["CASH"] = 1] = "CASH";
    PaymentType[PaymentType["CARD"] = 2] = "CARD";
    PaymentType[PaymentType["STANDBY"] = 3] = "STANDBY";
})(PaymentType || (exports.PaymentType = PaymentType = {}));
var ExtraPaymentType;
(function (ExtraPaymentType) {
    ExtraPaymentType[ExtraPaymentType["UNKNOWN"] = 0] = "UNKNOWN";
    ExtraPaymentType[ExtraPaymentType["SHOWER_TOKEN"] = 1] = "SHOWER_TOKEN";
    ExtraPaymentType[ExtraPaymentType["WASHING_MACHINE"] = 2] = "WASHING_MACHINE";
    ExtraPaymentType[ExtraPaymentType["OTHER"] = 3] = "OTHER";
})(ExtraPaymentType || (exports.ExtraPaymentType = ExtraPaymentType = {}));
//# sourceMappingURL=types.js.map